import { IModalTypes } from './types';

export function submitModalRequest() {
  return {
    type: IModalTypes.SUBMIT_MODAL_REQUEST,
  };
}
export function submitModalSuccess() {
  return {
    type: IModalTypes.SUBMIT_MODAL_SUCCESS,
  };
}
export function submitModalFailure() {
  return {
    type: IModalTypes.SUBMIT_MODAL_FAILURE,
  };
}
export function submitModalReset() {
  return {
    type: IModalTypes.SUBMIT_MODAL_RESET,
  };
}
